module.exports = __webpack_public_path__ + "img/bld.68137131.png";